import React from 'react';
import { SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

const ItemsToReturnSkeleton = () => {
  return (
    <div className="sui-my-24 sui-mt-4" data-testid="itemsskeleton">
      <SkeletonLine variant="heading" />

      {Array.from({ length: 2 }, (unused, index) => (
        <React.Fragment key={index}>
          <div className="sui-flex sui-flex-row mass-return-skeleton-margin sui-items-start sui-gap-3">
            <div id="massReturnSkeleton">
              <SkeletonBlock />
            </div>
            <div className="mass-return-skeleton-flex ">
              <SkeletonLine numberOfLines={2} />
            </div>
          </div>
          <div className="sui-mb-5 sui-mt-8">
            <SkeletonLine variant="multi" numberOfLines={2} />
          </div>
        </React.Fragment>
      ))}

      <div className="sui-mb-5 sui-mt-8">
        <SkeletonLine variant="multi" numberOfLines={2} />
      </div>
    </div>
  );
};

export default ItemsToReturnSkeleton;
